<template>
  <v-layout column>
    <v-flex>
      <sub-header :subHeaderConfig="subHeaderConfig" />
    </v-flex>
    <v-flex>
      <v-container fluid class="main-content-ctr over-view-cnr">
        <v-layout
          v-if="eventType == 2"
          align-start
          justify-start
          class="titleBar clearfix publish-time"
        >
          <v-flex md8 lg8 offset-md2 offset-lg2>
            <div class>
              <span class="label">Last published in production</span>
              <span class="time">{{publishedTime}}</span>
            </div>
          </v-flex>
        </v-layout>
        <v-layout align-start justify-start class="titleBar clearfix general-info">
          <v-flex md8 lg8 offset-md2 offset-lg2>
            <div class="stepHeader">
              <v-layout class="form-control">
                <span>General Information</span>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
        <v-layout v-for="(info,index) in generalInformation" class="row info-row" :key="index">
          <v-flex md2 lg2 offset-md2 offset-lg2 class="info-label">
            <span :autoid="info.keyautoid">{{info.displayName}}</span>
          </v-flex>
          <v-flex md6 lg6 class="info-value">
            <Span :id="info.copyText ? info.refId : ''" :autoid="info.valueautoid">{{info.value}} </Span>
            <a v-if="info.copyText" @click="copyJwt(info.copyText, info.refId)">
                <v-icon  color="blue">content_copy</v-icon>
                <span class='copied' :class="[ info.refId ]" ></span>
            </a>
          </v-flex>
        </v-layout>

        <v-layout align-start justify-start class="titleBar clearfix selected-products">
          <v-flex md8 lg8 offset-md2 offset-lg2>
            <div class="stepHeader">
              <v-layout class="form-control">
                <span>Selected Products</span>
              </v-layout>
            </div>
            <v-layout
              class="reviewCtr product-name"
              v-for="(product,index) in selectedProducts"
              :key="index"
            >
              <div class="lg12 md12" :autoid="product.autoid">{{product.displayName}}</div>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout v-if="showEnabledAppSection" align-start justify-start class="titleBar clearfix">
          <v-flex md8 lg8 offset-md2 offset-lg2>
            <div class="stepHeader">
              <v-layout class="form-control">
                <span>Enabled Applications</span>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
        <v-layout
          v-if="showEnabledAppSection"
          v-for="(application,index) in enabledApplication"
          class="row enabled-apps"
          :key="index"
        >
          <v-flex md2 lg2 offset-md2 offset-lg2 v-if="application.enabled" class="app">
            <span :autoid="application.autoid">{{application.value}}</span>
          </v-flex>
          <v-flex md6 lg6 row>
            <v-flex
              md4
              lg4
              v-for="(finapp, name, index) in application.finapps"
              :key="index"
              :class="['finapp']"
            >
              <span>{{finapp.dispVal}}</span>
            </v-flex>
          </v-flex>
        </v-layout>
        <v-layout align-start justify-start class="titleBar clearfix details">
          <v-flex md8 lg8 offset-md2 offset-lg2>
            <div class="stepHeader">
              <v-layout class="form-control">
                <span>Support Team Details</span>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
        <v-layout class="details-header">
          <v-flex
            :class="[isChannelPartner !==  true? 'md2 lg2':'md3 lg3' ,'header']"
            offset-md2
            offset-lg2
          >
            <span autoid="suppt-team-col-name-txt-lbl">Name</span>
          </v-flex>
          <v-flex class="header" md2 lg2 v-if="isChannelPartner !== true">
            <span autoid="suppt-team-col-user-id-txt-lbl">User ID</span>
          </v-flex>
          <v-flex :class="[isChannelPartner !== true ? 'md2 lg2':'md3 lg3' ,'header']">
            <span autoid="suppt-team-col-email-addr-txt-lbl">Email Address</span>
          </v-flex>
          <v-flex class="header" md2 lg2>
            <span autoid="suppt-team-col-cont-number-txt-lbl">Contact Number</span>
          </v-flex>
        </v-layout>
        <v-layout class="detail-row" v-for="(detail, index) in supportDetails" :key="index">
          <v-flex
            :class="[isChannelPartner !== true ? 'md2 lg2':'md3 lg3' ,'detail-col']"
            offset-md2
            offset-lg2
          >
            <span>{{detail.firstName}} {{detail.lastName}}</span>
          </v-flex>
          <v-flex v-if="isChannelPartner !== true" class="detail-col" md2 lg2>
            <span>{{detail.userId}}</span>
          </v-flex>
          <v-flex :class="[isChannelPartner !== true ? 'md2 lg2':'md3 lg3' ,'detail-col']">
            <span>{{detail.email}}</span>
          </v-flex>
          <v-flex class="detail-col" md2 lg2>
            <span>{{detail.contactNumber}}</span>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>
<script>
import moment from 'moment'
import { jsonHelper } from '../../mixins/jsonHelper'
import SubHeader from '../../components/subheader.vue'
import { subbrandToolHelper } from '../../mixins/subbrandToolHelper'

export default {
  components: {
    'sub-header': SubHeader
  },
  data() {
    return {
      eventType: '',
      isChannelPartner: ''
    }
  },
  mixins: [jsonHelper, subbrandToolHelper],
  computed: {
    subHeaderConfig() {
      let config = {
        headerText: this.$store.state.appStore.selectedSubbrandInfo.name,
        headerSubText:
          'ID: ' + this.$store.state.appStore.selectedSubbrandInfo.cobrandId,
        backLink: {
          text: this.$route.params.backText,
          link: this.$route.params.backLink
        },
        actions: [
          {
            displayName: 'Edit',
            controlName: 'button',
            actionType: 'primary',
            actionMethod: this.editSubrand,
            outlined: true,
            autoid: 'edit-btn',
            disabled: this.updatedOnPublish(
              this.$store.state.appStore.selectedSubbrandInfo
            ).disabled
          },
          {
            displayName: 'Configure Apps',
            controlName: 'button',
            actionType: 'primary',
            autoid: 'customize-app-btn',
            actionMethod: this.loadCustomizationTool,
            disabled: (this.updatedOnPublish(
              this.$store.state.appStore.selectedSubbrandInfo
            ).disabled) || !this.showEnabledAppSection
          }
        ]
      }

      return config
    },
    publishedTime() {
      return this.$store.state.subbrandOverviewStore.publishedTime
    },
    generalInformation() {
      return this.$store.state.subbrandOverviewStore.generalInformation
    },
    selectedProducts() {
      return this.$store.state.subbrandOverviewStore.selectedProducts
    },
    enabledApplication() {
      return this.$store.state.subbrandOverviewStore.enabledApplication
    },
    showEnabledAppSection() {
      return this.$store.state.createSubbrandStore.customerType == 'API_APP' ? true : false
    },
    supportDetails() {
      return this.$store.state.subbrandOverviewStore.supportDetails
    }
  },
  created() {
    this.parseOverviewData(this.$route.params.subbrandConfigData)

    this.$nextTick(function() {
      document.getElementById('back-to-sub-brand-list-btn').focus()
    })
  },
  methods: {
    updatedOnPublish(item) {
      return this.envMapping(item)
    },
    loadCustomizationTool() {
      // this.$store.state.appStore.selectedSubbrandInfo
      this.$router.push('/customization')
    },
    parseOverviewData(data) {
      console.log('parse data')
      this.$store.state.subbrandOverviewStore = {}
      this.eventType = data.eventType
      this.isChannelPartner = this.isChannelPartnerData(data)

      this.$store.state.subbrandOverviewStore.publishedTime = this.getSubbrandPublishedTime(
        data
      )
      this.$store.state.subbrandOverviewStore.generalInformation = this.prepareGeneralInformationData(
        data
      )
      this.$store.state.subbrandOverviewStore.selectedProducts = this.prepareSelectedProductsData(
        data.productConfig
      )
      this.$store.state.subbrandOverviewStore.enabledApplication = this.prepareEnabledApplicationsData(
        data.appConfig
      )
      this.$store.state.subbrandOverviewStore.supportDetails = this.prepareSupportDetailsData(
        data.contacts
      )
    },
    getSubbrandPublishedTime(data) {
      return new moment(String(data.publishedOn)).format('LLL')
    },
    isChannelPartnerData(data) {
      var supportOwner = ''

      switch (data.generalConfig.tier1CustomerCare) {
        case 'CHANNEL_PARTNER':
          supportOwner = true
          break
        case 'SUBBRAND':
          supportOwner = false
          break
        default:
          'NA'
      }
      return supportOwner
    },
    prepareGeneralInformationData(data) {
      let infos = []
      console.log('prepareGeneralInformationData')

      var supportOwner = ''

      switch (data.generalConfig.tier1CustomerCare) {
        case 'CHANNEL_PARTNER':
          supportOwner = 'Channel Partner'
          break
        case 'SUBBRAND':
          supportOwner = 'Sub-brand'
          break
        default:
          'NA'
      }

      infos.push({
        displayName: 'Customer support owner',
        value: supportOwner,
        keyautoid: 'cust-suppt-own-txt-lbl',
        valueautoid: 'cust-suppt-own-value-txt-lbl'
      })
      
      var customerTypeVal = ''
      if (data.generalConfig.customerType == 'API_APP') {
        customerTypeVal = 'API & Apps'
      } else {
        customerTypeVal = 'API only'
      }

      infos.push({
        displayName: 'Type of Customer',
        value: customerTypeVal,
        keyautoid: 'cust-type-txt-lbl',
        valueautoid: 'cust-type-value-txt-lbl'
      })

      let order = []
      if (data.generalConfig.customerType == 'API_APP') {
        order = ['node', 'ycc', 'ysl']
        this.$store.state.createSubbrandStore.customerType = 'API_APP'
      } else {
        order = ['ycc', 'ysl']
        this.$store.state.createSubbrandStore.customerType = 'API'
      }

      let urlConfig = data.urlConfig
      let dispName = {
        nodeDevLabel: 'Application Private URL',
        nodeProdLabel: 'Application Public URL',
        yccDevLabel: 'YCC Private URL',
        yccProdLabel: 'YCC Public URL',
        yslDevLabel: 'API Private URL',
        yslProdLabel: 'API Public URL'
      }
      let autoids = {
        nodeKeyDevAutoid: 'appl-dev-url-txt-lbl',
        nodeValueDevAutoid: 'appl-dev-url-value-txt-lbl',
        nodeKeyProdAutoid: 'appl-prod-url-txt-lbl',
        nodeValueProdAutoid: 'appl-prod-url-value-txt-lbl',
        yccKeyDevAutoid: 'ycc-dev-url-txt-lbl',
        yccValueDevAutoid: 'ycc-dev-url-value-txt-lbl',
        yccKeyProdAutoid: 'ycc-prod-url-txt-lbl',
        yccValueProdAutoid: 'ycc-prod-url-value-txt-lbl',
        yslKeyDevAutoid: 'ysl-dev-url-txt-lbl',
        yslValueDevAutoid: 'ysl-dev-url-value-txt-lbl',
        yslKeyProdAutoid: 'ysl-prod-url-txt-lbl',
        yslValueProdAutoid: 'ysl-prod-url-value-txt-lbl'
      }

      for (let key in order) {
        infos.push({
          displayName: dispName[order[key] + 'DevLabel'],
          value: urlConfig.development.external[order[key] + 'Url'],
          keyautoid: autoids[order[key] + 'KeyDevAutoid'],
          valueautoid: autoids[order[key] + 'ValueDevAutoid']
        })
        if (this.eventType == 2) {
          infos.push({
            displayName: dispName[order[key] + 'ProdLabel'],
            value: urlConfig.production.external[order[key] + 'Url'],
            keyautoid: autoids[order[key] + 'KeyProdAutoid'],
            valueautoid: autoids[order[key] + 'ValueProdAutoid']
          })
        }
      }
      
      let jwtIssuerID = data.authConfig
      let dispLabel = {
        jwtDevLabel: 'JWT Private Issuer ID',
        jwtProdLabel: 'JWT Public Issuer ID',
      }
      
      if(jwtIssuerID.development && jwtIssuerID.development.auths.jwt) {
          jwtIssuerID.development.auths.jwt.forEach((jwtList, index)=>{
            infos.push({
              displayName: dispLabel.jwtDevLabel,
              value: jwtList.issuerId,
              keyautoid: 'jwt-dev-auth-issuerid-txt-lbl',
              valueautoid: 'jwt-dev-auth-issuerid-value-txt-lbl',
              copyText: jwtList.issuerId,
              refId:'dev-jwt-key'+index
            })
          })
      }
      if (this.eventType == 2) {
          if(jwtIssuerID.production && jwtIssuerID.production.auths.jwt) {
            jwtIssuerID.production.auths.jwt.forEach((jwtList, index)=>{
                infos.push({
                  displayName: dispLabel.jwtProdLabel,
                  value: jwtList.issuerId,
                  keyautoid: 'jwt-prod-auth-issuerid-txt-lbl',
                  valueautoid: 'jwt-prod-auth-issuerid-value-txt-lbl',
                  copyText: jwtList.issuerId,
                  refId:'prod-jwt-key'+index
                })
            })
          }
        }
        
      return infos
    },
    prepareSelectedProductsData(data) {
      console.log('prepareSelectedProductsData')
      let products = []

      let dispName = {
        aggregation: {
          displayName: 'Aggregation',
          autoid: 'product-aggregation-txt-lbl'
        },
        verification: {
          displayName: 'Verification',
          autoid: 'product-verification-txt-lbl'
        }
      }

      for (let key in data) {
        let mergedObj = Object.assign({}, data[key], dispName[key])

        if (mergedObj.enabled) {
          products.push({
            displayName: mergedObj.displayName ? mergedObj.displayName : key,
            autoid: mergedObj.autoid
          })
        }
      }

      return products
    },
    prepareEnabledApplicationsData(data) {
      console.log('prepareEnabledApplicationsData')
      let applications = []

      let displayName = {
        fl: {
          value: 'Yodlee FastLink',
          autoid: 'enabled-appl-FL3-txt-lbl'
        },
        pfm: {
          value: 'Yodlee Financial Wellness FinApps',
          autoid: 'enabled-appl-PFM3-txt-lbl'
        }
      }

      var finappDispName = {
        Accounts: 'Accounts',
        Budget: 'Budget',
        'Cash Flow Analysis': 'Cash Flow Analysis',
        Dashboard: 'Dashboard',
        'Expense and Income Analysis': 'Expense and Income Analysis',
        'AI FinCheck': 'Fincheck',
        'Investment Holdings': 'Investment Holdings',
        'Net Worth Summary': 'Networth Summary',
        'Ok to Spend': 'OK to Spend',
        'Save for a Goal': 'Save for a Goal',
        Settings: 'Settings',
        Transactions: 'Transactions'
      }

      let dispOrder = Object.keys(displayName)

      for (let index in dispOrder) {
        let key = dispOrder[index]
        if (data[key].enabled) {
          if (data[key].finapps) {
            data[key].finapps = (object => {
              var newObject = {}
              var keys = []

              for (var key in object) {
                keys.push(key)
              }

              for (var i = keys.length - 1; i >= 0; i--) {
                var value = object[keys[i]]
                newObject[keys[i]] = value
              }
              return newObject
            })(data[key].finapps)

            for (let finapp in data[key].finapps) {
              if (data[key].finapps[finapp].enabled) {
                data[key].finapps[finapp].dispVal =
                  finappDispName[data[key].finapps[finapp].value]
              } else {
                delete data[key].finapps[finapp]
              }
            }
          }
          applications.push(Object.assign(data[key], displayName[key]))
        }
      }
      return applications
    },
    prepareSupportDetailsData(data) {
      console.log('prepareSupportDetailsData')
      return data.members
    },
    routeToEditSubrandSuccess() {
      let publishedStatus = this.$store.state.appStore.selectedSubbrandInfo
        .status
      this.$router.push({
        name: 'editSubbrand',
        params: {
          backLink: '/dataloader', //this.$router.history.current.path,
          backText: 'Back to Sub-brands List',
          isDraft: publishedStatus === 7
        }
      })
    },
    routeToEditSubrandFailure() {
      console.log('No Data')
    },
    editSubrand() {
      this.getSubbrandinfo(
        this.$store.state.appStore.selectedSubbrandInfo,
        this.routeToEditSubrandSuccess,
        this.routeToEditSubrandFailure
      )
    },
    copyJwt(text, id) {
        const el = document.createElement('textarea');  
        el.value = text;                                 
        el.setAttribute('readonly', '');                
        el.style.position = 'absolute';                     
        el.style.left = '-9999px';                      
        document.body.appendChild(el);  
        el.select();                                    
        document.execCommand('copy');                   
        document.body.removeChild(el); 
        $(".copied."+id).text("Copied").show().fadeOut(1200);
    }
  }
}
</script>
<style lang="scss">
.action-ctr {
  .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #0070c9 !important;
    opacity: 0.5 !important;
    color: #fff !important;
  }
  .v-btn.v-btn--disabled {
    color: #0070c9 !important;
    opacity: 0.5 !important;
  }
}

.over-view-cnr {
  .hide {
    display: none;
  }
  .stepHeader {
    margin-bottom: 8px;
  }
  .publish-time {
    margin-bottom: 32px;
    padding-left: 16px;
    span.label {
      font-size: 15px;
      color: #666666;
    }
    span.time {
      margin-left: 8px;
      font-size: 15px;
      // color: #0070c9;
      font-weight: 500;
      color: #383838;
    }
  }
  .general-info {
    .stepHeader {
      margin-bottom: 12px;
    }
  }
  .info-row {
    // height: 18px;
    line-height: 18px;
    font-size: 15px;
    margin-bottom: 22px;
    &:last-child {
      margin-bottom: 40px;
    }
    .info-label {
      color: #888888;
      padding-left: 16px;
      padding-right: 8px;
    }
    .info-value {
      color: #383838;
    }
  }
  .selected-products {
    .product-name {
      margin-bottom: 16px;
      padding-left: 16px;
      height: 24px;
      font-size: 15px;
      font-weight: 500;
      color: #383838;
      // &:last-child {
      //   margin-bottom: 40px;
      // }
    }
  }
  .enabled-apps {
    margin-bottom: 16px;
    color: #383838;
    font-size: 15px;
    &:last-child {
      margin-bottom: 40px;
    }
    .app {
      padding-left: 16px;
      font-weight: 500;
    }
    .finapp {
      margin-bottom: 16px;
    }
  }
  .enabled-apps + .enabled-apps {
    margin-bottom: 0;
    div.app {
      span {
        margin-bottom: 16px;
        display: inline-block;
      }
    }
  }
  .details {
    .stepHeader {
      margin-bottom: 0;
    }
  }
  .details-header {
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    color: #888888;
    .header {
      background: #fafafa;
      box-shadow: inset 0px -1px 0px #d6d6d6;
      &:first-child {
        padding-left: 16px;
      }
      &:last-child {
        padding-right: 16px;
      }
    }
  }
  .detail-row {
    // height: 40px;
    // line-height: 40px;
    font-size: 15px;
    &:last-child {
      margin-bottom: 40px;
    }
    .detail-col {
      word-break: break-all;
      box-shadow: inset 0px -1px 0px #d6d6d6;
      padding: 11px 0;
      padding-right: 6px;
      &:first-child {
        padding-left: 16px;
      }
      &:last-child {
        padding-right: 16px;
      }
    }
  }
  .copied {
      color: #519d2f;
      font-weight: bold;
      padding-left: 4px;
  }
}
</style>
